import capitalize from 'lodash/capitalize';

/**
 * Returns a user's (consumer | grantor | grantee) name - last, first
 */
export function getUserName(person?: { firstName?: string; lastName?: string }): string {
  if (!person) {
    return 'Guest';
  }

  const { firstName, lastName } = person;

  if (firstName && lastName) {
    const formattedFirstName = capitalize(firstName.toLowerCase());
    const formattedLastName = capitalize(lastName.toLowerCase());

    return `${formattedFirstName} ${formattedLastName}`;
  }

  return 'Guest';
}

export const getUserInitials = (name: string) => {
  if (!name) return '';
  const names = name.split(' ');
  const initials = names.length > 1 ? names[0][0] + names[names.length - 1][0] : names[0][0];

  return initials.toUpperCase();
};

export function getUserAge(person?: { age: string }) {
  if (!person?.age) {
    return 'No Age Available';
  }

  return person.age;
}
